import Send from '@mui/icons-material/Send'
import Build from '@mui/icons-material/Build'
import Top from '@mui/icons-material/ArrowUpward'
import Bottom from '@mui/icons-material/ArrowDownward'
import Back from '@mui/icons-material/ArrowBack'
import Next from '@mui/icons-material/ArrowForward'
import MenuIcon from '@mui/icons-material/Menu'
import Power from '@mui/icons-material/PowerSettingsNewTwoTone'
import MoreIcon from '@mui/icons-material/MoreVert'
import ResetIcon from '@mui/icons-material/StopCircleOutlined'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import LogoutIcon from '@mui/icons-material/Logout';
import Edit from '@mui/icons-material/Edit';
import Undo from '@mui/icons-material/Undo';
import Comment from '@mui/icons-material/Comment';
import AddComment from '@mui/icons-material/AddComment';
import Download from '@mui/icons-material/DownloadForOffline';
import UploadFile from '@mui/icons-material/UploadFile';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ArrowRight from '@mui/icons-material/ArrowRight';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowUp from '@mui/icons-material/ArrowDropUp';
import ArrowDown from '@mui/icons-material/ArrowDropDown';
import { SvgIcon, SvgIconOwnProps } from '@mui/material';
import Leaderboard from '@mui/icons-material/Leaderboard';
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import MoreVert from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton' // FOR client usage

/**
 * Icons
 * https://mui.com/material-ui/material-icons
 */
export const Icons = {
    Send,
    Build,
    Back,
    Next,
    Top,
    Bottom,
    SvgIcon: Send, // FIXME
    MenuIcon,
    Power,
    MoreIcon,
    ResetIcon,
    DragIcon: DragIndicatorIcon,
    DotsMenu: MoreVert,
    LockOutlinedIcon,
    LogoutIcon,
    Edit,
    Undo,
    Comment,
    AddComment,
    Download,
    UploadFile,
    ArrowBack: KeyboardDoubleArrowLeftIcon,
    ArrowForward: KeyboardDoubleArrowRightIcon,
    ArrowBackL: ArrowBack,
    ArrowForwardL: ArrowForward,
    ArrowRight,
    ArrowLeft,
    ArrowUp,
    ArrowDown,
    Leaderboard,
    CloseIcon,
    CheckIcon
}

export type IconType = typeof SvgIcon;
export type IconProps = React.ComponentProps<IconType>; //FIXME SvgIconOwnProps not working with style